<div class="model-form-page">

  <div class="model-header-actions">

    <div class="header-left-part">
      <button class="back-button" (click)="goBack()" [title]="'BUTTON.BACK' | translate">
        <fa-icon [icon]="faArrowLeft"></fa-icon>
      </button>

      <div class="model-name-input-wrapper">
        <input type="text" class="model-name-input" [(ngModel)]="modelForm.name"
          [placeholder]="'MODELS.FIELDS.NAME_PLACEHOLDER' | translate" />
      </div>

      @if (!isEditing) {
        <div class="model-type-select-wrapper">
          <select class="model-type-select" [(ngModel)]="modelType" (ngModelChange)="onModelTypeChange()">
            <option value="extraction">{{ 'SIMULATIONS.TYPE.EXTRACTION' | translate }}</option>
            <option value="classification">{{ 'SIMULATIONS.TYPE.CLASSIFICATION' | translate }}</option>
            <option value="processing">{{ 'SIMULATIONS.TYPE.PROCESSING' | translate }}</option>
          </select>
        </div>
      }
      @if (isEditing) {
        <span class="model-type-badge" [class]="'type-' + modelType">
          {{ 'SIMULATIONS.TYPE.' + modelType.toUpperCase() | translate }}
        </span>
      }
    </div>

    <div class="header-right-part">
      @if (canImportModel) {
        <button class="secondary-btn" [disabled]="saving" (click)="importModel()">
          <fa-icon [icon]="faUpload"></fa-icon>
          <span>{{ 'BUTTON.IMPORT' | translate }}</span>
        </button>
      }

      @if (isEditing) {
        <button class="secondary-btn" [disabled]="saving" (click)="exportModel()">
          <fa-icon [icon]="faDownload"></fa-icon>
          <span>{{ 'BUTTON.EXPORT' | translate }}</span>
        </button>
      }

      <button class="primary-btn" [disabled]="saving || !canSaveModel" (click)="saveModel()">
        <span>{{ isEditing ? ('BUTTON.SAVE' | translate) : ('BUTTON.CREATE' | translate) }}</span>
      </button>
    </div>
  </div>

  <div class="model-editor-card">
    <div class="model-editor-body">

      <app-tabs [tabs]="computedTabs" [(activeId)]="activeTab" variant="underline" [fullWidth]="true"
        (helpClicked)="onHelpClicked($event)">
      </app-tabs>

      @if (formKey) {
        <div class="tab-panels">
          <div class="tab-panel" [class.active]="activeTab === 'basic'" [hidden]="activeTab !== 'basic'">
            @if (basicUserListInitial !== undefined) {
              <app-models-form [initialValue]="basicUserListInitial"
                [showSaveFormatOption]="false" (mentionDataChange)="onMentionDataChange($event)"
                (valueChange)="onBasicFormChange($event)">
              </app-models-form>
            }
          </div>
          <div class="tab-panel" [class.active]="activeTab === 'rules'" [hidden]="activeTab !== 'rules'">
            <hr class="models-divider" />
            @if (generalRulesInitial !== undefined) {
              <app-models-form formType="generalRules"
                [initialValue]="generalRulesInitial" [showSaveFormatOption]="false" [mentionData]="mentionData"
                (valueChange)="onRulesFormChange($event)">
              </app-models-form>
            }
          </div>
          <div class="tab-panel" [class.active]="activeTab === 'questions'" [hidden]="activeTab !== 'questions'">
            <hr class="models-divider" />
            @if (generalQuestionsInitial !== undefined) {
              <app-models-form formType="generalQuestions"
                [initialValue]="generalQuestionsInitial" [showSaveFormatOption]="false" [mentionData]="mentionData"
                (valueChange)="onQuestionsFormChange($event)">
              </app-models-form>
            }
          </div>
          <div class="tab-panel" [class.active]="activeTab === 'operations'" [hidden]="activeTab !== 'operations'">
            <app-processing-operations
              [operations]="operations"
              [allowTest]="false"
              (operationsChange)="onOperationsChange($event)">
            </app-processing-operations>
          </div>
          <div class="tab-panel" [class.active]="activeTab === 'catalog'" [hidden]="activeTab !== 'catalog'">
            <app-processing-catalog
              [catalog]="catalogData"
              [catalogError]="catalogError"
              (retry)="onCatalogRetry()">
            </app-processing-catalog>
          </div>
          <div class="tab-panel" [class.active]="activeTab === 'classification'" [hidden]="activeTab !== 'classification'">
            <hr class="models-divider" />
            <app-classification-config
              [initialValue]="classificationInitial"
              (valueChange)="onClassificationFormChange($event)">
            </app-classification-config>
          </div>
        </div>
      }
    </div>
  </div>

  <app-modal-help 
    [show]="showHelpModal" 
    [title]="helpModalTitle" 
    [content]="helpModalContent"
    (close)="closeHelpModal()">
  </app-modal-help>

</div>
